import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
    withCredentials: true
});

export class PowertranzFetchAPI {


    static async sale(data, X_PowerTranz_BaseUrl,  token) {
        const res = await server(`/powertranz`, {
            method: "post",
            data: data,
            headers: {
                "x-access-token": token,
            },

        });
        return res
    }

    static async payment(data, token) {
        const res = await server(`/powertranz/payment`, {
            method: "post",
            data: data,
            headers: {
                "x-access-token": token,
            },

        });
        return res
    }

    static async auth(data, X_PowerTranz_Id, X_PowerTranz_Password, X_PowerTranz_BaseUrl, X_PowerTranz_MerchantResponseUrl, branchoffice_id) {
        const res = await server(`/spi/auth`, {
            method: "POST",
            data: data,
            headers: {
                "X-PowerTranz-Id": X_PowerTranz_Id,
                "X-PowerTranz-Password": X_PowerTranz_Password,
                "X-PowerTranz-MerchantResponseUrl": X_PowerTranz_MerchantResponseUrl,
                "X-BranchOffice-Id": branchoffice_id
            }
        });
        return res
    }


    /*static async sale(data, X_PowerTranz_Id, X_PowerTranz_Password, X_PowerTranz_BaseUrl, X_PowerTranz_MerchantResponseUrl, branchoffice_id) {
         console.log(process.env.REACT_APP_API_URL_RENDER_PAYMENT_PROCCESSOR)
         const res = await server(`/spi/sale`, {
             method: "post",
             data: data,
             headers: {
                 "X-PowerTranz-Id": X_PowerTranz_Id,
                 "X-PowerTranz-Password": X_PowerTranz_Password,
                 "X-PowerTranz-BaseUrl": X_PowerTranz_BaseUrl,
                 "X-PowerTranz-MerchantResponseUrl": X_PowerTranz_MerchantResponseUrl,
                 "X-BranchOffice-Id": branchoffice_id
             },
             
         });
         return res
     }
 
     static async auth(data, X_PowerTranz_Id, X_PowerTranz_Password, X_PowerTranz_BaseUrl, X_PowerTranz_MerchantResponseUrl, branchoffice_id) {
         const res = await server(`/spi/auth`, {
             method: "POST",
             data: data,
             headers: {
                 "X-PowerTranz-Id": X_PowerTranz_Id,
                 "X-PowerTranz-Password": X_PowerTranz_Password,
                 "X-PowerTranz-BaseUrl": X_PowerTranz_BaseUrl,
                 "X-PowerTranz-MerchantResponseUrl": X_PowerTranz_MerchantResponseUrl,
                 "X-BranchOffice-Id": branchoffice_id
             }
         });
         return res
     }
 
     static async capture(data, X_PowerTranz_Id, X_PowerTranz_Password, X_PowerTranz_BaseUrl, X_PowerTranz_MerchantResponseUrl, branchoffice_id) {
         const res = await server(`/capture`, {
             method: "POST",
             data: data,
             headers: {
                 "X-PowerTranz-Id": X_PowerTranz_Id,
                 "X-PowerTranz-Password": X_PowerTranz_Password,
                 "X-PowerTranz-BaseUrl": X_PowerTranz_BaseUrl,
                 "X-BranchOffice-Id": branchoffice_id
             }
         });
         return res
     }
 
     static async payment(data, X_PowerTranz_Id, X_PowerTranz_Password, X_PowerTranz_BaseUrl, X_PowerTranz_MerchantResponseUrl, branchoffice_id) {
         const res = await server(`/spi/payment`, {
             method: "POST",
             data: data,
             headers: {
                 "X-PowerTranz-Id": X_PowerTranz_Id,
                 "X-PowerTranz-Password": X_PowerTranz_Password,
                 "X-PowerTranz-BaseUrl": X_PowerTranz_BaseUrl,
                 "X-BranchOffice-Id": branchoffice_id
             }
         });
         return res
     }
 
     static async refund(data, X_PowerTranz_Id, X_PowerTranz_Password, X_PowerTranz_BaseUrl, X_PowerTranz_MerchantResponseUrl, branchoffice_id) {
         const res = await server(`/transactions/refund`, {
             method: "POST",
             data: data,
             headers: {
                 "X-PowerTranz-Id": X_PowerTranz_Id,
                 "X-PowerTranz-Password": X_PowerTranz_Password,
                 "X-PowerTranz-BaseUrl": X_PowerTranz_BaseUrl,
                 "X-BranchOffice-Id": branchoffice_id
             }
         });
         return res
     }
 
     static async void(data, X_PowerTranz_Id, X_PowerTranz_Password, X_PowerTranz_BaseUrl, X_PowerTranz_MerchantResponseUrl, branchoffice_id) {
         const res = await server(`/transactions/void`, {
             method: "POST",
             data: data,
             headers: {
                 "X-PowerTranz-Id": X_PowerTranz_Id,
                 "X-PowerTranz-Password": X_PowerTranz_Password,
                 "X-PowerTranz-BaseUrl": X_PowerTranz_BaseUrl,
                 "X-BranchOffice-Id": branchoffice_id
             }
         });
         return res
     }
 
     static async void(data, X_PowerTranz_Id, X_PowerTranz_Password, X_PowerTranz_BaseUrl, TxId, branchoffice_id) {
         const res = await server(`/transactions/${TxId}`, {
             method: "GET",
             data: data,
             headers: {
                 "Accept": "application/json",
                 "X-PowerTranz-Id": X_PowerTranz_Id,
                 "X-PowerTranz-Password": X_PowerTranz_Password,
                 "X-PowerTranz-BaseUrl": X_PowerTranz_BaseUrl,
                 "X-BranchOffice-Id": branchoffice_id
             }
         });
         return res
     }*/

}




